
/* Easybooth — IzyRent prefill, guarded version (2026-10-13)
 * Does not query IzyRent inventory or override its availability.
 * Stops on invalid dates/time/quantity and never submits an order itself.
 */
(function () {
  'use strict';

  var DEBUG = false;
  var MAX_REQUESTED_QTY = 7; // physical fleet; NOT an availability calculation
  var hideStyleId = 'izyrent-automation-hide';
  var finished = false;

  function log() {
    if (DEBUG) console.log.apply(console, ['[AutoPrefill]'].concat([].slice.call(arguments)));
  }
  function hideUI() {
    if (document.getElementById(hideStyleId)) return;
    var s = document.createElement('style');
    s.id = hideStyleId;
    s.textContent = '.flatpickr-calendar, #izyMultiBook, #izyMultiBook2, #izyrent_timeslots { visibility:hidden !important; pointer-events:none !important; }';
    document.head.appendChild(s);
  }
  function showUI() {
    var s = document.getElementById(hideStyleId);
    if (s) s.remove();
  }
  function fail(message) {
    if (finished) return;
    finished = true;
    showUI();
    console.warn('[AutoPrefill] ' + message);
    var existing = document.getElementById('easybooth-prefill-notice');
    if (!existing) {
      existing = document.createElement('div');
      existing.id = 'easybooth-prefill-notice';
      existing.setAttribute('role', 'alert');
      existing.style.cssText = 'padding:12px 16px;margin:12px 0;border:1px solid #d97706;border-radius:8px;background:#fff7ed;color:#7c2d12;font-size:15px;';
      var anchor = document.querySelector('#izyMultiBook2, #izyMultiBook, product-info, main');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(existing, anchor);
      else document.body.prepend(existing);
    }
    existing.textContent = 'La sélection automatique n’a pas pu être confirmée (' + message + '). Vérifiez les dates, l’heure et la quantité dans IzyRent avant de poursuivre. / Automatic selection could not be confirmed. Please check dates, time and quantity.';
  }
  function poll(check, success, failure, interval, attempts) {
    var n = 0;
    var timer = setInterval(function () {
      if (finished) { clearInterval(timer); return; }
      var value = null;
      try { value = check(); } catch (err) { log(err); }
      if (value) { clearInterval(timer); success(value); }
      else if (++n >= attempts) { clearInterval(timer); failure(); }
    }, interval);
  }
  function findFlatpickr() {
    var inputs = document.querySelectorAll('input');
    for (var i = 0; i < inputs.length; i++) if (inputs[i]._flatpickr) return inputs[i]._flatpickr;
    return null;
  }
  function normalizeTime(value) {
    var match = String(value || '').trim().match(/^(\d{1,2})(?::(\d{2}))?/);
    if (!match) return '';
    var h = Number(match[1]), m = Number(match[2] || 0);
    if (h > 23 || m > 59) return '';
    return String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0');
  }
  function validISO(s) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(s || '')) return false;
    var d = new Date(s + 'T12:00:00');
    return !isNaN(d.getTime()) && [d.getFullYear(), String(d.getMonth()+1).padStart(2,'0'), String(d.getDate()).padStart(2,'0')].join('-') === s;
  }
  function unavailable() {
    var roots = document.querySelectorAll('#izyMultiBook, #izyMultiBook2, #izyrent_timeslots');
    for (var i=0; i<roots.length; i++) {
      var text = roots[i].textContent || '';
      if (/\b(?:stock|quantity)\s*:\s*-\d+|\b-999\b/i.test(text)) return true;
      if (/\bunavailable\b|\bindisponible\b/i.test(text)) return true;
    }
    return false;
  }
  function setDates(fp, start, end, done) {
    if (!validISO(start) || !validISO(end) || end < start) return fail('dates invalides');
    try {
      // Keep original date-picker semantics. IzyRent remains the availability authority.
      var far = new Date(); far.setFullYear(far.getFullYear() + 5);
      fp.set('maxDate', far);
      fp.setDate([new Date(start + 'T12:00:00'), new Date(end + 'T12:00:00')], true);
    } catch (e) { return fail('sélection des dates'); }
    setTimeout(function () { if (unavailable()) fail('période indisponible'); else done(); }, 1200);
  }
  function setDuration(duration, done) {
    if (!duration) return done();
    var d = Number(duration);
    if (!Number.isInteger(d) || d < 1) return fail('durée invalide');
    poll(function () { return document.querySelector('.duration-btn[data-days="' + d + '"], [data-duration="' + d + '"]'); },
      function (btn) { if (btn.disabled) return fail('durée non disponible'); btn.click(); setTimeout(function () { if (unavailable()) fail('période indisponible'); else done(); }, 450); },
      function () { fail('durée introuvable'); }, 150, 40);
  }
  function setTime(time, done) {
    if (!time) return done();
    var wanted = normalizeTime(time);
    if (!wanted) return fail('heure invalide');
    poll(function () {
      var slots = document.querySelectorAll('.time-slot-btn, #izyrent_timeslots .one-slot');
      for (var i=0; i<slots.length; i++) {
        var slot = slots[i];
        if (normalizeTime(slot.getAttribute('data-time') || slot.textContent) === wanted &&
          !slot.disabled && slot.getAttribute('aria-disabled') !== 'true' &&
          !slot.classList.contains('booked-slot') && !slot.classList.contains('past-slot')) return slot;
      }
      return null;
    }, function (slot) {
      slot.click();
      setTimeout(function () {
        if (unavailable()) return fail('heure ou période indisponible');
        // Preserve the original IzyRent Save step, scoped to its time-slot area where possible.
        var buttons = document.querySelectorAll('#izyrent_timeslots button, .flatpickr-calendar button');
        for (var j=0; j<buttons.length; j++) {
          if (/^save$/i.test((buttons[j].textContent || '').trim())) { buttons[j].click(); break; }
        }
        done();
      }, 450);
    }, function () { fail('heure indisponible ou introuvable'); }, 150, 60);
  }
  function setQuantity(qty, done) {
    if (!qty) return done();
    var requested = Number(qty);
    if (!Number.isInteger(requested) || requested < 1 || requested > MAX_REQUESTED_QTY) return fail('quantité invalide');
    poll(function () { return document.querySelector('#izyMultiBook2, #izyMultiBook'); }, function (widget) {
      var input = widget.querySelector('.izyMultiInput');
      var plus = widget.querySelector('.addizy');
      var minus = widget.querySelector('.subizy');
      if (!input || !plus || !minus) return fail('contrôle de quantité IzyRent introuvable');
      var clicks = 0, stagnant = 0, previous = null;
      var timer = setInterval(function () {
        if (finished) { clearInterval(timer); return; }
        var current = Number(input.value);
        if (!Number.isInteger(current) || current < 1 || current > MAX_REQUESTED_QTY || unavailable()) {
          clearInterval(timer); return fail('stock IzyRent incohérent ou indisponible');
        }
        if (current === requested) { clearInterval(timer); return done(); }
        if (previous === current) stagnant++; else stagnant = 0;
        if (stagnant >= 3 || clicks >= MAX_REQUESTED_QTY + 1) {
          clearInterval(timer); return fail('quantité refusée par IzyRent');
        }
        previous = current;
        var button = current < requested ? plus : minus;
        if (button.disabled || button.getAttribute('aria-disabled') === 'true') {
          clearInterval(timer); return fail('quantité non disponible');
        }
        button.click(); clicks++;
      }, 350);
    }, function () { fail('widget IzyRent introuvable'); }, 200, 30);
  }
  function setAddons(logo, access, done) {
    // Preserve optional add-on prefill. Missing options never force checkout.
    function apply() {
      if (logo) {
        var logoValue = logo === 'Logo/text' ? 'Logo/text (+30$)' : 'No logo';
        document.querySelectorAll('input[name*="Logo or text on the photo"]').forEach(function (r) {
          if (r.value === logoValue && !r.checked) { r.click(); r.dispatchEvent(new Event('change', {bubbles:true})); }
        });
      }
      if (access) {
        var accessValue = access === 'Full access' ? 'Full access(+30$)' : 'No access';
        document.querySelectorAll('input[name*="Full gallery access"]').forEach(function (r) {
          if (r.value === accessValue && !r.checked) { r.click(); r.dispatchEvent(new Event('change', {bubbles:true})); }
        });
      }
    }
    apply(); var tries=0;
    var timer=setInterval(function () { apply(); if (++tries>=8) {clearInterval(timer); done();} }, 500);
  }
  function init() {
    var p = new URLSearchParams(window.location.search);
    var start = p.get('start_date'), end = p.get('end_date'), time = p.get('time');
    var duration = p.get('duration'), qty = p.get('quantity');
    var logo = p.get('logo_option'), access = p.get('access_option');
    var autoBook = p.get('auto_book') === 'true';
    if (!(start || end || time || duration || qty || logo || access)) return;
    // Never auto-click Continue. The customer must review the actual IzyRent availability.
    if (autoBook) log('auto_book ignored for safety; manual confirmation required');
    hideUI();
    poll(findFlatpickr, function (fp) {
      if (!start || !end) return fail('dates manquantes');
      setDates(fp, start, end, function () {
        setDuration(duration, function () {
          setTime(time, function () {
            setQuantity(qty, function () {
              setAddons(logo, access, function () {
                finished = true;
                showUI();
                log('Prefill completed; awaiting customer confirmation');
              });
            });
          });
        });
      });
    }, function () { fail('calendrier IzyRent introuvable'); }, 300, 60);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
